import { render, staticRenderFns } from "./ActivateAccountResetPassword.vue?vue&type=template&id=7b1356e2&"
import script from "./ActivateAccountResetPassword.vue?vue&type=script&lang=js&"
export * from "./ActivateAccountResetPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports